@if (messageType) {
  <p-message severity="error" styleClass="mt-2" closable i18n>
    <i class="pi pi-exclamation-triangle mr-2 text-color"></i>
    <span class="text-xl font-semibold">
      @switch (messageType) {
        @case ('ACCESS_DENIED') {
          You do not have access to view this resource.
        }
        @case ('DISABLED') {
          The page you are trying to view is not currently available.
        }
      }
    </span>
  </p-message>
}
<div id="dashboard" class="grid grid-nogutter">

  <div class="md:col-9 col-12 grid grid-nogutter">
    <div id="applications" class="col-12">
      @if (!loadingApplications) {
        <p-dataview #dv [value]="applications" emptyMessage="No applications assigned to you" i18n-emptyMessage
                    [loading]="loadingApplications">
          <ng-template #list let-applications>
            <div class="grid">
              @for (app of applications; track $index; let first = $first, oddRow = $odd) {
                <div class="column">
                  <!--                <div class="column col-12 md:col-6 lg:col-4">-->
                  <div
                    class="app-row flex flex-column sm:flex-row sm:align-items-center p-2 gap-2 border-bottom-1 h-120px"
                    [class.surface-border]="!first">
                    @if (app.icon) {
                      <div class="h-70px w-10rem relative"
                           [style]="'background-image:url(' + app.icon + ');background-size:cover;border-radius:8px;background-position:center center'"></div>
                    } @else {
                      <div class="h-70px w-10rem relative"
                           style="background-image:url('/assets/img/App-icon-default.png');background-size:cover;border-radius:8px;background-position:center center"></div>
                    }
                    <div
                      class="flex flex-column md:flex-row justify-content-between md:align-items-center flex-1 gap-4">
                      <div class="flex flex-row md:flex-column justify-content-between align-items-start gap-2">
                        <div>
                          <span class="font-medium text-secondary text-xs expert-code">{{ app.expertCode }}</span>
                          <div class="text-lg font-medium text-900 mt-2 app-name">{{ app.title || app.name }}</div>
                        </div>
                      </div>
                      <div class="flex flex-column md:align-items-end gap-5">
                        <div class="flex flex-row-reverse md:flex-row gap-2">
                          <a pButton
                             tabindex="0"
                             (keyup.space)="loadApp(app)"
                             (keyup.enter)="loadApp(app)"
                             href="{{loadUrl(app)}}"
                             class="p-button flex-auto md:flex-initial white-space-nowrap"
                             [loading]="app.loading"
                             [attr.aria-label]="'Open ' + (app.title || app.name)"
                             i18n>OPEN</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              }
            </div>
          </ng-template>
        </p-dataview>
      } @else {
        <div class="flex flex-column mx-auto my-auto">
          <p-progress-spinner animationDuration="1s" class="mx-auto"/>
          <h3 i18n>Loading Applications...</h3>
        </div>
      }
    </div>
    @if (isDealerMember) {
      <div id="dealer-metrics" class="col-12">
        <div class="col-12 grid" style="border-top: 1px solid var(--background-darkgrey);margin-top:1rem;width:100%">
          @if (!loadingMetrics) {
            <div class="col-12 flex flex-column">
              <div class="col-12 chart-3 gap-5 flex flex-row">
                @if (dealerSurveyChartData) {
                  <div class="col-6" style="aspect-ratio: 2">
                    <h4 i18n>Customer Experience Measures (R6)</h4>
                    <p-chart type="bar" [data]="dealerSurveyChartData" [options]="dealerSurveyChartOpts"/>
                  </div>
                }
                @if (dealerVehicleSalesChartData) {
                  <div class="col-6" style="aspect-ratio: 2">
                    <h4 i18n>Vehicle Sales Per Quarter, Current Fiscal Year</h4>
                    <p-chart type="bar" [data]="dealerVehicleSalesChartData"/>
                  </div>
                }
              </div>
              @if (dealerPartSalesChartData && hasRole("DealerAdmin")) {
                <div class="mx-auto col-6 chart-3 gap-5" style="aspect-ratio: 2">
                  <h4 i18n>Total Earnings Per Quarter, Current Fiscal Year</h4>
                  <p-chart type="bar" [data]="dealerPartSalesChartData"/>
                </div>
              }
            </div>
          } @else if (loadingMetrics) {
            <div class="flex flex-column mx-auto my-auto">
              <p-progress-spinner animationDuration="1s" class="mx-auto"/>
              <h3 i18n>Loading Dealership Metrics...</h3>
            </div>
          }
        </div>
      </div>
    }
  </div>

  <div id="notices" class="md:col-3 col-12 scrollable">
    <h2 class="text-center" i18n>Notifications</h2>
    @if (loadingBulletins) {
      <ul class="m-0 p-0 list-none">
        <li class="mb-4"><div class="flex"><div class="self-center" style="flex: 1"><p-skeleton width="100%" class="mb-2"/><p-skeleton width="75%"/></div></div></li>
        <li class="mb-4"><div class="flex"><div class="self-center" style="flex: 1"><p-skeleton width="100%" class="mb-2"/><p-skeleton width="75%"/></div></div></li>
        <li class="mb-4"><div class="flex"><div class="self-center" style="flex: 1"><p-skeleton width="100%" class="mb-2"/><p-skeleton width="75%"/></div></div></li>
        <li class="mb-4"><div class="flex"><div class="self-center" style="flex: 1"><p-skeleton width="100%" class="mb-2"/><p-skeleton width="75%"/></div></div></li>
        <li class="mb-4"><div class="flex"><div class="self-center" style="flex: 1"><p-skeleton width="100%" class="mb-2"/><p-skeleton width="75%"/></div></div></li>
        <li class="mb-4"><div class="flex"><div class="self-center" style="flex: 1"><p-skeleton width="100%" class="mb-2"/><p-skeleton width="75%"/></div></div></li>
        <li class="mb-4"><div class="flex"><div class="self-center" style="flex: 1"><p-skeleton width="100%" class="mb-2"/><p-skeleton width="75%"/></div></div></li>
      </ul>
    } @else {
      @if (bulletins.length === 0) {
        <p i18n>No notifications found</p>
      } @else {
        <p-accordion expandIcon="pi pi-chevron-down" collapseIcon="pi pi-chevron-up">
          @for (bulletin of sortedBulletins; track $index) {
            <p-accordion-panel [value]="bulletin.bulletin!.id" (click)="markAsRead(bulletin)">
              <p-accordion-header class="{{ getReadStatus(bulletin) }}">
                <div class="m-2 {{ getReadStatus(bulletin) === 'unread' ? undefined : 'font-normal' }}">
                  {{ bulletin.bulletin?.subject }}
                </div>
              </p-accordion-header>
              <p-accordion-content>
                <p>{{ bulletin.bulletin?.emailMessage }}</p>
                @if (bulletin.document) {
                  <ul>
                    <li><a class="attachment"
                           href="{{ downloadDocument(bulletin.bulletin!.id, bulletin.document.id!) }}"
                           target="_blank" rel="noopener noreferrer">Bulletin
                      Document: {{ bulletin.document.filename }}</a></li>
                    @for (attachment of bulletin.attachments; track attachment) {
                      <li><a class="attachment" href="{{ downloadAttachment(bulletin.bulletin!.id, attachment.id!) }}"
                             target="_blank">Attachment Document: {{ attachment.filename }}</a></li>
                    }
                  </ul>
                }
              </p-accordion-content>
            </p-accordion-panel>
          }
        </p-accordion>
        @if (messageType === "SAVE_STATUS_ERROR") {
          <p-message severity="error" closable i18n>Failed to save read status for the bulletin</p-message>
        }
      }
    }
  </div>
</div>
